import { render, staticRenderFns } from "./StudentGeneralTaskTeaser.vue?vue&type=template&id=028f8372&scoped=true&"
import script from "./StudentGeneralTaskTeaser.vue?vue&type=script&lang=js&"
export * from "./StudentGeneralTaskTeaser.vue?vue&type=script&lang=js&"
import style0 from "./StudentGeneralTaskTeaser.vue?vue&type=style&index=0&id=028f8372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f8372",
  null
  
)

export default component.exports